import { useState } from "react";
import TextInput from "./TextInput";

interface Option {
  id: string;
  label: string;
  sublabel?: string;
}

interface Props {
  placeholder?: string;
  options: Option[];
  excludeIds: string[];
  onSearchChange: (value: string) => void;
  onPick: (option: Option) => void;
  loading?: boolean;
}

export default function EntityPicker({ placeholder, options, excludeIds, onSearchChange, onPick, loading }: Props) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);

  const visible = options.filter((o) => !excludeIds.includes(o.id));

  return (
    <div className="bo-picker">
      <TextInput
        type="search"
        value={query}
        placeholder={placeholder ?? "Rechercher…"}
        onChange={(e) => {
          setQuery(e.target.value);
          onSearchChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 120)}
      />
      {open && (
        <div className="bo-picker__results">
          {loading ? (
            <div className="bo-picker__empty">Recherche en cours…</div>
          ) : visible.length === 0 ? (
            <div className="bo-picker__empty">Aucun résultat.</div>
          ) : (
            visible.map((option) => (
              <button
                key={option.id}
                type="button"
                className="bo-picker__item"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  onPick(option);
                  setQuery("");
                  onSearchChange("");
                  setOpen(false);
                }}
              >
                <div style={{ fontWeight: 600 }}>{option.label}</div>
                {option.sublabel && (
                  <div style={{ fontSize: 11, color: "var(--ink-mute)" }}>{option.sublabel}</div>
                )}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
